import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Carousel from './Carousel';
import { removeDomainName, setDataAttr } from '../../../utils/helper';
import './CategoryCarousel.scss';
import { connect } from 'react-redux';

class CategoryCarousel extends Component {
  static propTypes = {
    categoryCarouselData: PropTypes.object,
    categoryData: PropTypes.array,
  };

  constructor(props) {
    super(props);
    this.carouselConfig = {
      dots: false,
      slidesToShow: 3,
      slidesToScroll: 3,
      pauseOnHover: true,
      responsive: [
        {
          breakpoint: 1023,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: true,
            dots: false,
            swipeToSlide: true,
          },
        },
      ],
    };
  }

  viewRange = (paramA, paramB) => {
    window.viewRange = true;
    if (window.dtm.LenskartRewamp) window.dtm.LenskartRewamp.Home.click.viewrange(paramA, paramB);
  };

  render() {
    const { categoryCarouselData, categoryData, style, dataLocale, localeInfo } = this.props;
    const dataAttr =
      categoryCarouselData.gaObj && Object.keys(categoryCarouselData.gaObj).length > 0
        ? setDataAttr(categoryCarouselData.gaObj)
        : null;
    const { VIEW_RANGE, VIEW_IN_3D, LOGO } = dataLocale;
    const { catId } = categoryCarouselData;
    const dtmClick = categoryCarouselData.dtm;
    const dtmCat = categoryCarouselData.dtmCat ? categoryCarouselData.dtmCat : 'cat';
    const processedData = [];
    let products;
    let data;
    if (categoryData) {
      data = categoryData.find(data => parseInt(data.cat_id, 10) === catId);
      products = data ? data.products : [];
    }
    if (!categoryData) {
      return (
        <div
          style={{
            height: '200px',
            background:
              'url(https://static.lenskart.com/media/mobile/images/img-loader.gif) center no-repeat',
          }}
        ></div>
      );
    } else if (products && products.length) {
      return (
        <section className="catSlider second" style={style}>
          <div key={`${catId}custom-slider`}>
            <div className="catSlider_desc">
              <div className="catSlider_desc_heading">
                <strong>{categoryCarouselData.heading}</strong> {categoryCarouselData.category}
              </div>
              <div className="catSlider_desc_shortDesc1">{categoryCarouselData.shortDesc}</div>
              <div className="catSlider_desc_shortDesc2">
                <span className="font-desc-second">{categoryCarouselData.shortDescSecond}</span>
                <span className="catSlider_desc_shortDesc2_info">
                  {categoryCarouselData.shortDescThird}
                </span>
              </div>
            </div>

            {products && products.length >= 3 ? (
              <React.Fragment>
                {products.forEach(banner => {
                  const slideDataAttr =
                    banner.gaObj && Object.keys(banner.gaObj).length > 0
                      ? setDataAttr(banner.gaObj)
                      : null;
                  processedData.push(
                    <div
                      key={`carousel-category${banner.id}${catId}`}
                      className="catSlider_carouselItem"
                    >
                      <Link
                        rel="noopener noreferrer"
                        target="_blank"
                        to={{
                          pathname: removeDomainName(banner.url, '', localeInfo?.countryCode),
                          state: { productId: banner.id, section: 'prod' },
                        }}
                      >
                        <img
                          {...slideDataAttr}
                          alt={LOGO}
                          className="getGaData sliderImg"
                          src={banner.image}
                          title={banner.title}
                        />
                      </Link>
                    </div>
                  );
                })}
                <Carousel
                  carouselConfig={this.carouselConfig}
                  carouselHtmlData={processedData}
                ></Carousel>
              </React.Fragment>
            ) : (
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                {products &&
                  products.map(banner => {
                    const slideDataAttr =
                      banner.gaObj && Object.keys(banner.gaObj).length > 0
                        ? setDataAttr(banner.gaObj)
                        : null;
                    return (
                      <div
                        key={`carousel-category${banner.id}${catId}`}
                        className="catSlider_carouselItem"
                      >
                        <Link
                          rel="noopener noreferrer"
                          target="_blank"
                          to={{
                            pathname: removeDomainName(banner.url, '', localeInfo?.countryCode),
                            state: { productId: banner.id, section: 'prod' },
                          }}
                        >
                          <img
                            {...slideDataAttr}
                            alt={LOGO}
                            className="getGaData sliderImg"
                            src={banner.image}
                            title={banner.title}
                          />
                        </Link>
                      </div>
                    );
                  })}
              </div>
            )}
            <center>
              <div style={{ width: '100%', display: 'inline-block' }}>
                <Link
                  className="catSlider_btn"
                  to={{
                    pathname: removeDomainName(
                      categoryCarouselData.viewRange,
                      '',
                      localeInfo?.countryCode
                    ),
                    state: { categoryId: catId, section: 'cat' },
                  }}
                >
                  <div
                    {...dataAttr}
                    className="getGaData catSlider_btn_view-range2"
                    style={{ background: '#3b9f95', color: '#fff' }}
                    onClick={() => this.viewRange(dtmCat, dtmClick)}
                  >
                    {VIEW_RANGE}
                  </div>
                </Link>
                {categoryCarouselData.threeD && (
                  <Link
                    className="view_3d isWebCamElement catSlider_btn"
                    to={removeDomainName(categoryCarouselData.threeD, '', localeInfo?.countryCode)}
                    onClick={() => this.viewRange(dtmCat, dtmClick)}
                  >
                    <div {...dataAttr} className="getGaData catSlider_btn_view-range2">
                      {VIEW_IN_3D}
                    </div>
                  </Link>
                )}
              </div>
            </center>
          </div>
        </section>
      );
    }
    return <div></div>;
  }
}

CategoryCarousel.defaultProps = {
  categoryData: null,
};

const mapStateToProps = state => ({
  localeInfo: state?.common?.localeInfo,
});

export default connect(mapStateToProps, null)(CategoryCarousel);
